import React, { useState } from "react";
import "./DependentInfo.css";

import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown";
import CustomSwitch from "../../Components/CustomSwitch/CustomSwitch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import PlusIcon from "../../assets/images/client-dashboard/dependentinfo-addbtnicn.svg";
import { useNavigate } from "react-router-dom";
const ClientDashboardDependentInfo = () => {
  const [residentialAddresses, setResidentialAddresses] = useState([
    { year: 2020, state: "", from: "", to: "" },
  ]);
  const navigate = useNavigate();
  const addResidentialAddress = (index) => {
    const newYear = residentialAddresses[index]?.year + 1;
    if (!residentialAddresses.some((address) => address.year === newYear)) {
      setResidentialAddresses((prevAddresses) => [
        ...prevAddresses,
        {
          year: newYear,
          state: "",
          from: "",
          to: "",
        },
      ]);
    } else {
      // Handle the case when the year already exists (e.g., show an error message)
      // You can add your own logic here
    }
  };
  const removeResidentialAddress = (index) => {
    setResidentialAddresses((prevAddresses) =>
      prevAddresses.filter((_, i) => i !== index)
    );
  };
  return (
    <div className="clientdashboard__depndtinfo_section">
      <div className="clientdashboard__depndtinfo_banner">
        <div className="clientdashboard__depndtinfo_bannerleft">
          Dependent Info
        </div>
        <div className="clientdashboard__depndtinfo_bannerright">
          <button
            className="clientdashboard__depndtinfo_adddepinfobtn"
            onClick={() => navigate("/client-dashboard/bi-adddependent-info")}
          >
            <img src={PlusIcon} />
            <span>Add Dependent</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardDependentInfo;
